
import { WPQPage1, WPQ_Groove_Detail } from "./WPQObjects/WPQ_entity";
import { checkProcessAdded, checkduplicateProcess, page1characters } from "./WPQObjects/WPQ_Validations";
import { Action } from "../utility/common/constants/CommonConstants";
import { validateForm, checkProcessAdded as commonCheckProcessAdded, checkDuplicateProcess as commonCheckDuplicateProcess } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import { todayDate } from "../utility/common/helpers/TodayDate";


/**
 * Unified WPQ validation function using TransactionValidationUtils
 * @param {Object} config - Validation configuration
 * @returns {Object} Validation result with errors and isError flag
 */
export const validateWPQForm = async ({
  headerObj,
  detailObj,
  WPStype,
  currentErrors = {},
  action,
  checkDuplicate,
}) => {
  // Filter detail objects to only include those with processes
  const filteredDetailObj = detailObj?.filter((item) => item.WPQ_Process !== "");

  // Use common validation function with detail config for SA type support
  const { errors: finalErrors, isError: hasErrors } = validateForm({
    headerObj,
    detailObj: filteredDetailObj,
    requiredFields: WPQPage1,
    currentErrors,
    todayDate,
  });

  let updatedErrors = { ...finalErrors };
  let updatedHasErrors = hasErrors;

  // WPQ-specific validations
  if (WPStype === "Overlay") {
    let data = page1characters(updatedErrors);
    if (data) {
      updatedHasErrors = true;
    }
  }

  // Duplicate check for new records
  if ((action === Action.ActionCopy || action === Action.ActionAdd) && !updatedHasErrors) {
    if (await checkDuplicate(WPStype, headerObj?.WPQ_WelderId, headerObj?.WPQ_RecordNo)) {
      updatedHasErrors = true;
      updatedErrors.WPQ_WelderId = {
        status: true,
        message: "Combination of Welder ID & WPQ Record Number already exists",
      };
    } else {
      updatedErrors.WPQ_WelderId = {
        status: false,
        message: "",
      };
    }
  }

  // Process validation using common utility
  let norows = commonCheckProcessAdded(detailObj, {
    processField: 'WPQ_Process',
    typeField: 'WPQ_Type',
    maxRows: 4
  });
  if (norows) {
    detailObj[0].errormessage = "At least one Process and Type is required";
    updatedHasErrors = true;
    detailObj[0].error = true;

    if (detailObj[0].WPQ_Process !== "" && detailObj[0].WPQ_Type !== "") {
      detailObj[0].error = false;
    }
  }

  // Check for duplicate processes using common utility
  let duplicateprocess = commonCheckDuplicateProcess(detailObj, {
    processField: 'WPQ_Process',
    typeField: 'WPQ_Type'
  });
  if (duplicateprocess) updatedHasErrors = true;

  return {
    errors: updatedErrors,
    isError: updatedHasErrors,
  };
};

/**
 * Unified WPQ temp validation function
 * @param {Object} config - Validation configuration
 * @returns {Object} Validation result
 */
export const validateWPQTempForm = async ({
  headerObj,
  detailObj,
  currentErrors = {},
  action,
  checkDuplicate,
  WPStype,
}) => {
  // Use minimal validation for temp save - only required fields
  const tempRequiredFields = {
    WPQ_WelderId: "",
    WPQ_RecordNo: ""
  };

  const { errors: tempErrors, isError } = validateForm({
    headerObj,
    requiredFields: tempRequiredFields,
    currentErrors,
  });

  let updatedErrors = { ...tempErrors };
  let updatedIsError = isError;

  // Duplicate check
  if ((action === Action.ActionCopy || action === Action.ActionAdd) && !updatedIsError) {
    if (await checkDuplicate(WPStype, headerObj?.WPQ_WelderId, headerObj?.WPQ_RecordNo)) {
      updatedIsError = true;
      updatedErrors.WPQ_WelderId = {
        status: true,
        message: "Combination of Welder ID & WPQ Record Number already exists",
      };
    } else {
      updatedErrors.WPQ_WelderId = {
        status: false,
        message: "",
      };
    }
  }

  // Process validation using common utility
  let norows = commonCheckProcessAdded(detailObj, {
    processField: 'WPQ_Process',
    typeField: 'WPQ_Type',
    maxRows: 4
  });
  if (norows) {
    detailObj[0].errormessage = "At least one Process and Type is required";
    updatedIsError = true;
    detailObj[0].error = true;

    if (detailObj[0].WPQ_Process !== "" && detailObj[0].WPQ_Type !== "") {
      detailObj[0].error = false;
    }
  }

  // Check for duplicate processes using common utility
  let duplicateprocess = commonCheckDuplicateProcess(detailObj, {
    processField: 'WPQ_Process',
    typeField: 'WPQ_Type'
  });
  if (duplicateprocess) updatedIsError = true;

  return {
    errors: updatedErrors,
    isError: updatedIsError,
  };
};